<app-traffic-deviation-bar [origin]="origin"></app-traffic-deviation-bar>